import { parseProgramDescription } from "helpers/jackrabbit/parseProgramDescription";
import { normalizeProgramHighlights } from "./normalizeProgramHighlights";

export function resolveProgramPageContent({
  description = "",
  overviewLead = "",
  overviewHighlights,
}) {
  const structuredHighlights = normalizeProgramHighlights(overviewHighlights);

  if (structuredHighlights.length > 0) {
    return {
      lead: overviewLead.trim() || description.trim(),
      highlights: structuredHighlights,
    };
  }

  const parsed = parseProgramDescription(description);
  return {
    lead: overviewLead.trim() || parsed.lead,
    highlights: parsed.highlights,
  };
}
